import React, { useMemo } from "react";
import { motion } from "framer-motion";
import getScrollAnimation from "./utils/getScrollAnimation";
import ScrollAnimationWrapper from "./Layout/ScrollAnimationWrapper";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import home_image from "../images/zyntegrate-infographic.png"
import { generateGuid } from "./../Common/utils/utils";

import Features from "./Features";

const Hero = () => {
  const scrollAnimation = useMemo(() => getScrollAnimation(), []);
  const navigate = useNavigate();

  const handleGetStarted = () => navigate("/integrations/listing");

  const gotoAddItem = () => {
    var newGuid = generateGuid();
    navigate(`/integrations/${newGuid}/overview`); // Navigate to the next page
    //router.push("/add-integration/overview"); // Navigates to the /about page
  };

  return (
    <>
      {/* Hero Section */}
      <div className="flex min-h-screen bg-gradient-to-br from-[#0f0f1a] to-[#1a1a2e] text-white relative">
        <Navbar />

        {/* Content */}
        <div className="relative flex flex-col lg:flex-row items-center justify-between px-6 sm:px-10 lg:px-16 py-16 gap-12">
          {/* Left Text Section */}
          <ScrollAnimationWrapper className="z-10 w-full lg:w-1/2">
            <motion.div
              className="text-center lg:text-left"
              variants={scrollAnimation}
            >
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight bg-gradient-to-r from-blue-400 to-indigo-500 bg-clip-text text-transparent uppercase tracking-wide">
                Zyntegrate
              </h1>
              <p className="mt-4 text-lg sm:text-xl text-gray-300">
                Powerful AI Integrations. Faster, Smarter, Unified.
              </p>
              <p className="mt-3 text-base sm:text-lg text-gray-400 whitespace-nowrap">
                Enter your integration details — <span className="font-semibold text-white">Zyntegrate</span> connects them instantly with AI-powered precision
                {/* <span className="font-semibold text-white">Zyntegrate</span> will
                connect them effortlessly. */}
              </p>

              <div className="flex justify-center lg:justify-start mt-6 space-x-10">
                <div className="mt-8">
                  <button onClick={handleGetStarted} className="bg-orange-500 hover:bg-orange-600 text-white font-medium px-6 py-3 rounded-xl shadow-lg transition-all duration-300 hover:scale-105">
                    Start Monitoring
                  </button>
                </div>

                <div className="mt-8">
                  <button onClick={gotoAddItem} className="bg-orange-500 hover:bg-orange-600 text-white font-medium px-6 py-3 rounded-xl shadow-lg transition-all duration-300 hover:scale-105">
                    Launch Builder
                  </button>
                </div>
              </div>
            </motion.div>
          </ScrollAnimationWrapper>

          <div className="relative hidden lg:block w-full max-w-lg z-10">
            {/* Gradient Background Behind Image */}
            <div className="absolute inset-0 h-[150%] left-[-25%] top-[-25%] bg-gradient-radial from-orange-500/30 via-transparent to-transparent opacity-80 blur-3xl z-0 rounded-full pointer-events-none" />

            {/* Foreground Image */}
            <img
              src={home_image}
              alt="Lightning Bolt"
              className="relative w-full h-auto z-10"
            />
          </div>
        </div>
      </div>

      {/* Separate Feature Section */}
      <Features />
    </>
  );
};

export default Hero;